export class SmartphotoBodyshopDetails {
    comment;
    constructor(smartphoto) {
        this.comment = smartphoto.bodyshop_comments;
    }
}
